import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'BakulatorBasic',
    component: () =>
      import(/* webpackChunkName: "test" */ '@/views/BakulatorBasic/bakulator-basic.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
